import React from 'react';
import Navbar from '../components/Navbar';
import HeroSection from '../components/HeroSection';
import RolesSection from '../components/RolesSection';
import CategorySection from '../components/CategorySection';
import HowItWorks from '../components/HowItWorks';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Background */}
      <div
        className="relative"
        style={{
          background: 'linear-gradient(135deg, #4f46e5 0%, #6366f1 25%, #8b5cf6 50%, #c4b5fd 75%, #fcd9b6 100%)',
          minHeight: '85vh',
        }}
      >
        <Navbar />
        <HeroSection />
      </div>
      
      {/* How It Works */}
      <HowItWorks />
      
      {/* Categories */}
      <CategorySection />
      
      {/* Featured Roles */}
      <RolesSection />
      
      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Home;
